import { useQueryClient } from '@tanstack/react-query';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import {
  SERVICE_AGREEMENT_LIST_QUERY_KEY,
  useDeactivateWealthPlanningService,
} from '../../../../../hooks/queries/privateBanking';
import { useCloseProductOutcome } from './useCloseProductOutcome';

export const useDeactivateExternallyServicedProduct = (serviceAgreement: ServiceAgreementV2, brUid: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending: isClosing } = useDeactivateWealthPlanningService();
  const { onClosed, onCloseFailed } = useCloseProductOutcome(brUid, serviceAgreement.serviceAgreementId);

  const close = async () => {
    try {
      await mutateAsync({ serviceAgreement, brUid });
    } catch (error) {
      onCloseFailed(error);
      return;
    }
    void queryClient.invalidateQueries({ queryKey: [SERVICE_AGREEMENT_LIST_QUERY_KEY] });
    onClosed();
  };

  return { close, isClosing };
};
